import React from "react";
import { useTranslation } from "react-i18next";
import { Close, Check } from "@mui/icons-material";

interface IBodyTemplateProps {
  rowData: any;
  field: string;
  header: string;
}

export function TextTemplate(props: IBodyTemplateProps) {
  return (
    <React.Fragment>
      <span className="p-column-title">{props.header}</span>
      {props.rowData[props.field]}
    </React.Fragment>
  );
}

export function DateTemplate(props: IBodyTemplateProps) {
  const { t } = useTranslation();

  return (
    <React.Fragment>
      <span className="p-column-title">{props.header}</span>
      {t("common.formattedDate", { dateString: props.rowData[props.field] })}
    </React.Fragment>
  );
}

export function BooleanTemplate(props: IBodyTemplateProps) {
  return (
    <React.Fragment>
      <span className="p-column-title">{props.header}</span>
      {props.rowData[props.field] ? <Check style={{ color: "green" }} /> : <Close style={{ color: "red" }} />}
    </React.Fragment>
  );
}
